<template>
	<div class="csoportok">
    <v-app id="tablazat">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <th class="text-center">
							Csoport neve
						</th>
            <th class="text-center">
							Csoport kezelése
						</th>
            <!--<th class="text-center">Csoport nyomtatása</th>-->
          </thead>
          <tbody>
            <tr v-for="csoport in csoportok" v-bind:key="csoport.id">
              <td class="text-center"> {{csoport.nev}} </td>
              <td class="text-center">
								<!--<router-link :to="{ name: 'csoportkezelese', params: {id: csoport.id} }"><v-btn color="lime">Kezelés</v-btn></router-link>-->
								<router-link :to="{ name: 'csoporteredmenybevitel', params: {id: csoport.id} }">
									<v-btn rounded color="lime">
										Adatbevitel
										<v-icon
							        right
							        dark
							      >
							        fa-keyboard
							      </v-icon>
									</v-btn>
								</router-link>
								<router-link :to="{ name: 'csoportgyakorlatok', params: {id: csoport.id} }">
									<v-btn rounded color="orange">
										Gyakorlatok
										<v-icon
							        right
							        dark
							      >
								       fa-dumbbell
							      </v-icon>
									</v-btn>
								</router-link>
								<router-link :to="{ name: 'csoportjegyek', params: {id: csoport.id} }">
									<v-btn rounded color="blue">
										Jegyek
										<v-icon
							        right
							        dark
							      >
							        fa-star
							      </v-icon>
									</v-btn>
								</router-link>
								<router-link :to="{ name: 'csoportdiagramok', params: {id: csoport.id} }">
									<v-btn rounded color="blue">
										Diagramok
										<v-icon
							        right
							        dark
							      >
							        fa-chart-bar
							      </v-icon>
									</v-btn>
								</router-link>
							</td>

              <!--<td class="text-center"> nyomtatás {{csoport.id}} </td>-->
            </tr>
            <tr>
              <td colspan="3">
                <v-form ref="csoporthozzaadasa"
                        lazy-validation
                >
                  <v-text-field
                    v-model="ujcsoportnev"
                    label="Csoport neve"
										prepend-inner-icon="fa-users"
                    required
                  ></v-text-field>
                  <v-btn
                    color="success"
                    @click="ujcsoport"
										v-if="ujcsoportnev"
										rounded
                  >
                    Létrehozás
										<v-icon
							        right
							        dark
							      >
							        fa-plus
							      </v-icon>
                  </v-btn>
									<v-dialog
							      v-model="sablonvalasztodialogus"
							      persistent
							      max-width="600px"
										v-if="ujcsoportnev"
							    >
							      <template v-slot:activator="{ on, attrs }">
							        <v-btn
							          color="yellow"
							          dark
							          v-bind="attrs"
							          v-on="on"
												rounded
							        >
							          Létrehozás sablonból/meglévő csoportból
												<v-icon
									        right
									        dark
									      >
									        fa-copy
									      </v-icon>
							        </v-btn>
							      </template>
							      <v-card>
											<v-card-title>
							          <span class="headline">Sablon/meglévő csoport kiválasztása</span>
							        </v-card-title>
							        <v-card-text>
												<v-select
													required
								          :items="sablonokescsoportok"
													item-text="nev"
													item-value="id"
													v-model="valasztottsablonvagymeglevocsoport"
								          label="Sablon/meglévő csoport"
													prepend-icon="fa-users"
								        ></v-select>
							        </v-card-text>
							        <v-card-actions>
							          <v-spacer></v-spacer>
							          <v-btn
							            color="blue darken-1"
							            text
							            @click="sablonvalasztodialogus = false"
							          >
							            Mégsem
													<v-icon
										        right
										        dark
										      >
										        fa-times
										      </v-icon>
							          </v-btn>
							          <v-btn
							            color="blue darken-1"
							            text
							            @click="ujcsoportsablonbol"
							          >
							            Létrehozás
													<v-icon
										        right
										        dark
										      >
										        fa-plus
										      </v-icon>
							          </v-btn>
							        </v-card-actions>
							      </v-card>
							    </v-dialog>
                </v-form>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-app>
	</div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/
     import router from "../router"

export default {

  data: function () {
  	return {
  		csoportok: [],
			sablonok: [],
			sablonvalasztodialogus: false,
			valasztottsablonvagymeglevocsoport: 1,
      ujcsoportnev: '',
			sablonokescsoportok: []
  	}
  },
	computed: {
	},
  methods: {
  	csoportokfrissitese: function () {
      var ideiglenescsoport = []
  		this.axios
  			.get(this.$store.state.backendeleres+'csoportok')
  			.then(response => {this.csoportok = response.data.csoportok;
					for(var i = 0; i<response.data.sablonok.length;i++){
				 		this.sablonokescsoportok.push({nev: "SABLON: "+response.data.sablonok[i].nev, id: response.data.sablonok[i].id})
				  }
					for(var i = 0; i<response.data.csoportok.length;i++){
				 		this.sablonokescsoportok.push({nev: response.data.csoportok[i].nev, id: response.data.csoportok[i].id})
						this.valasztottsablonvagymeglevocsoport = response.data.csoportok[i].id
				  }
          if(response.data.bejelentkezve==false){
                    this.$store.commit('bejelentkezve', false)
                    router.push('/bejelentkezes');
                    this.$store.commit('admin',false)
            }
          })
  	},
    ujcsoport: function () {
      this.axios
        .post(this.$store.state.backendeleres+'csoportok', { nev: this.ujcsoportnev })
        .then(response => {
          if (response.data.ok) {
            this.csoportok.push({ id: response.data.id, nev: response.data.nev })
          }
          if(response.data.bejelentkezve==false){
                  this.$store.commit('bejelentkezve', false)
                  router.push('/bejelentkezes');
                  this.$store.commit('admin',false)
          }
        })
      this.ujcsoportnev = ''
    },
		ujcsoportsablonbol: function() {
			this.axios
				.post(this.$store.state.backendeleres+'csoportok/letrehozassablonbol/'+this.valasztottsablonvagymeglevocsoport, { nev: this.ujcsoportnev })
				.then(response => {
					if (response.data.ok) {
						this.csoportok.push({ id: response.data.id, nev: response.data.nev })
					}
					if(response.data.bejelentkezve==false){
									this.$store.commit('bejelentkezve', false)
									router.push('/bejelentkezes');
									this.$store.commit('admin',false)
					}
				})
			this.ujcsoportnev = ''
			this.sablonvalasztodialogus=false;
		}
  },
  mounted () {
    this.csoportokfrissitese()
  }
}
</script>
